
export const categoriesOrder = [
    'Laundry',
    'Refrigeration',
    'Cooking',
    'Dishwasher',
    'LG Studio',
];

export const categoryNamesInEnglish = {
    "Dishwasher": "Dishwasher",
    "Cooking": "Cooking",
    "Laundry": "Laundry",
    "Refrigeration": "Refrigeration",
    "LG Studio": "LG Studio"
};
export const categoryNamesInFrench = {
    "Cooking": "Cuisson",
    "Dishwasher": "Lave-vaisselle",
    "Laundry": "Lessive",
    "Refrigeration": "Réfrigérateur",
    "LG Studio": "LG Studio"
};
export const categoryDescriptionEN = {
    "Cooking": `The star of the show, LG kitchen ranges & ovens offer precision and performance unlike any others in the market. With a variety of innovative features, our ranges can help you create dishes that will leave your guests demanding an encore.`,
    "Dishwasher": `LG’s sleek and powerful dishwashers will make your dishes shine. With intuitive controls, adjustable racks, and a large load capacity LG dishwashers make kitchen clean up a breeze.`,
    "LG Studio": `Say hello to the LG Studio Kitchen. With innovative freestanding and built-in appliances that perform flawlessly and look awesome, you may never want to leave your home again.`,
    "Laundry": `Whether you’re looking for side-by-side laundry machines, stackable washers and dryers, or all-in-one laundry appliances that offer powerful washing and drying in a single, space-saving machine, LG offers a wide range of reliable, innovative solutions.`,
    "Refrigeration": `Make the most out of life. Whether you’re replacing a kitchen appliance, adding a laundry room or furnishing your whole house, look to LG for stylish and innovative appliances that fit your lifestyle and match your home’s décor.`,
};
export const categoryDescriptionFR = {
    "Cooking": `Que vous recherchiez des appareils de lavage côte à côte, des laveuses et des sécheuses empilables, ou des appareils tout-en-un qui offrent un lavage et un séchage puissants dans une seule unité compacte, LG offre une vaste gamme de solutions fiables et innovantes.`,
    "Dishwasher": `Élégants et puissants, les lave-vaisselle de LG feront briller votre vaisselle. Avec des commandes intuitives, des paniers ajustables et une grande capacité, les lave-vaisselle de LG peuvent désencombrer votre cuisine en un tour de main.`,
    "LG Studio": `Dites bonjour à la cuisine LG Studio. Grâce à ces appareils innovateurs non encastrés et intégrés qui ont fière allure et fonctionnent parfaitement, vous ne voudrez plus jamais sortir de votre maison.`,
    "Laundry": `Que vous recherchiez des appareils de lavage côte à côte, des laveuses et des sécheuses empilables, ou des appareils tout-en-un qui offrent un lavage et un séchage puissants dans une seule unité compacte, LG offre une vaste gamme de solutions fiables et innovantes.`,
    "Refrigeration": `Profitez pleinement de la vie. Que ce soit pour remplacer un électroménager de cuisine, ajouter une salle de lavage ou meubler votre maison, vous pouvez compter sur LG pour trouver des électroménagers élégants et novateurs qui correspondent à votre style de vie et s’harmonisent avec le décor de votre maison.`,
};

export const subcategoryNamesInEnglish = {
    "Cooking": [
        // "Electric Range", "Gas Range", "Built-in Wall Oven", "Built-in Cooktop", "Over-the-Range Microwave", "Countertop Microwave"
        "Electric Slide-in Ranges", "Electric Free-standing Ranges",
        "Induction Ranges", "Gas Ranges",
        "Wall Ovens", "Cooktops", "Over-the-Range Microwaves", "Countertop Microwaves"
    ],
    "Laundry": [
        "Front Load", "WashTower", "Top Load", "Specialty Laundry",
        // NEW
        "Accessories"
    ],
    "LG Studio": [
        // "Laundry", "Refrigeration", "Cooking", "Dishwasher",  
        "Laundry", "Refrigeration", "Built-in Cooking", "Free-standing Cooking", "Ventilation", "Dishwashers",
    ],
    "Dishwasher": [
        "Built-in"
    ],
    "Refrigeration": [
        // "French Door, Side-by-Side", "Top and Bottom Mount", "Column", "Kimchi"	
        "36\" French Door Standard Depth", "36\" French Door Counter Depth",
        "33\" French Door Standard Depth", "33\" French Door Counter Depth",
        "30\" French Door", "Top and Bottom Mount", "Side-by-Side", "Column", "Kimchi"
    ],
}




export const subcategoryOrderEN = {
    "LG Studio": [
        "Refrigeration",
        "Built-in Cooking",
        "Free-standing Cooking",
        "Ventilation",
        "Dishwashers",
        "Laundry",
    ],
    "Laundry": [
        "Front Load",
        "WashTower",
        "Top Load",
        "Specialty Laundry",
        "Accessories" // NEW
        // "Styler",

    ],
    "Refrigeration": [
        "36\" French Door Standard Depth",
        "36\" French Door Counter Depth",
        "33\" French Door Standard Depth",
        "33\" French Door Counter Depth",
        "30\" French Door",
        "Top and Bottom Mount",
        "Side-by-Side",
        "Column",
        "Kimchi",

    ],
    "Cooking": [
        "Electric Slide-in Ranges",
        "Electric Free-standing Ranges",
        "Induction Ranges",
        "Gas Ranges",
        "Wall Ovens",
        "Cooktops",
        "Over-the-Range Microwaves",
        "Countertop Microwaves",
    ],
    "Dishwasher": [
        "Built-in"
    ],

};

export const subcategoryOrderFR = {
    "LG Studio": [
        "Réfrigérateur",
        "Cuisson intégré",
        "Cuisson autonome",
        "Ventilation",
        "Lave-vaisselles",
        "Lessive",
    ],
    "Lessive": [
        "Chargement frontal",
        "WashTower",
        "Chargement vertical",
        "Appareils spécialisés",
        // "Styler"
    ],
    "Réfrigérateur": [
        "Porte à deux battants profondeur standard de 36 po",
        "Porte à deux battants profondeur de comptoir de 36 po",
        "Porte à deux battants profondeur standard de 33 po",
        "Porte à deux battants profondeur de comptoir de 33 po",
        "Porte à deux battants de 30 po",
        "Congélateur en haut et bas",
        "Côte-à-côte",
        "Colonne",
        "Kimchi"
    ],
    "Cuisson": [
        "Cuisinière encastrable électrique",
        "Cuisinières encastrable électriques",
        "Cuisinières à inductions",
        "Cuisinière au gaz",
        "Four mural",
        "Surface de cuisson",
        "Four à micro-ondes à hotte intégrée",
        "Four à micro-ondes de comptoir",
    ],
    "Lave-vaisselle": [
        "Intégré"
    ],

};




// THIS NEEDS TO BE UPDATED FOR SEARCH

export const CATEGORY_SUBCATEGORY_ORDER = {
    "air care": ["air care"],
    cooking: [
        'induction ranges',
        'electric ranges',
        'gas ranges',
        "over-the-range microwaves",
        "countertop microwaves",
        "built-in wall ovens",
        "built-in cooktops",
        "range hoods",
        "dual fuel ranges"
    ],
    laundry: [
        "washtower",
        "front load washers",
        "front load dryers",
        "top load washers",
        "top load dryers",
        "all-in-one",
        "specialty laundry",
        "stylers",
        "accessories",
    ],
    refrigeration: [
        "4-door french door",
        "3-door french door",
        "under 33\" french door",
        "side-by-side",
        "bottom and top freezer",
        "single door",
    ],
    signature: [
        "laundry",
        "ranges",
        "refrigeration",
        "dishwashers",
        "accessories",
    ],
    studio: [
        "laundry",
        "ranges",
        "refrigeration",

        "dishwashers",
        "microwaves",

        "built-in wall ovens",
        "built-in cooktops",
        "range hoods",
    ],
    vacuums: [
        'vacuums'
    ],
    dishwashers: [
        "pocket handle dishwashers",
        "towel bar handle dishwashers",
        "specialty dishwashers",
    ],

};

// NEW 2025 
export const CATEGORY_KEYWORDS_MAP = {
    Refrigeration: ["fridge", "freezer", "refrigerator"],
    Laundry: ["washer", "dryer", "laundry", "washers", "dryers"],
    Dishwashers: ["dishwasher", "dishwashers"],
    Cooking: ["cooking", "stove", "oven", "range", "cooktop"],
    Studio: ["designer", "contemporary", "luxury"],

    "Réfrigérateur": ["frigo", "congélateur", "réfrigérateur", "freezer", "refroidisseur"],
    "Lessive": ["laveuse", "sécheuse", "lessive", "lave-linge", "sèche-linge"],
    "Lave-vaisselle": ["lave-vaisselle", "vaisselle", "laveur de vaisselle", "machine à laver la vaisselle"],
    "Cuisson": ["cuisson", "cuisinière", "four", "plaque de cuisson", "table de cuisson"],
    "LG Studio": ["lg studio", "studio", "designer", "luxe", "haut de gamme"],
};



// NEW 2025 
export const SUBCATEGORY_KEYWORDS_MAP = {

    // UPDATE AS FOLLOWS 

    //  "Refrigeration":['','',],

    // AIR CARE
    "air care": ["air purifier", "air cleaner", "air filter"],
    // COOKING
    "induction ranges": ["induction stove", "induction oven", "induction cooktop"],
    "gas ranges": ["gas stove", "gas oven", "gas cooktop"],
    "electric ranges": ["electric stove", "electric oven", "electric cooktop"],
    "dual fuel ranges": ["dual fuel stove", "dual fuel oven", "gas electric range"],
    "built-in wall ovens": ["wall oven", "built-in oven", "in-wall oven"],
    "built-in cooktops": ["built-in cooktop", "counter cooktop", "stovetop"],
    "range hoods": ["oven hood", "stove vent", "kitchen hood"],
    "over-the-range microwaves": ["OTR microwave", "above stove microwave", "vent microwave"],
    "countertop microwaves": ["counter microwave", "tabletop microwave", "compact microwave"],

    // LAUNDRY
    "all-in-one": ["washer dryer combo", "all-in-one washer", "combo washer dryer"],
    "washtower": ["stacked washer dryer", "vertical washer dryer", "wash tower"],
    "accessories": ["laundry accessories", "washer accessories", "dryer accessories"],
    "specialty laundry": ["compact washer", "compact dryer", "portable washer"],
    "front load washers": ["front washer", "front load washer", "horizontal washer"],
    "top load washers": ["top washer", "top load washer", "vertical washer"],
    "front load dryers": ["front dryer", "front load dryer", "horizontal dryer"],
    "top load dryers": ["top dryer", "top load dryer", "vertical dryer"],
    "stylers": ["clothing care", "garment steamer", "clothes refresher"],

    // REFRIGERATION
    "4-door french door": ["four door fridge", "4-door fridge", "quad door fridge"],
    "3-door french door": ["three door fridge", "3-door fridge", "french door fridge"],
    "under 33\" french door": ["small fridge", "compact fridge", "narrow fridge"],
    "side-by-side": ["side fridge", "double door fridge", "vertical fridge"],
    "bottom and top freezer": ["bottom freezer", "top freezer", "standard fridge"],
    "single door": ["single fridge", "one door fridge", "standalone fridge"],

    // DISHWASHERS
    "pocket handle dishwashers": ["hidden handle dishwasher", "sleek dishwasher", "integrated handle dishwasher"],
    "towel bar handle dishwashers": ["bar handle dishwasher", "towel handle dishwasher", "traditional handle dishwasher"],
    "specialty dishwashers": ["compact dishwasher", "portable dishwasher", "drawer dishwasher"],

    // VACUUMS
    "vacuums": ["vacuum cleaner", "stick vacuum", "cordless vacuum"],

    // SIGNATURE
    "laundry": ["premium laundry", "luxury washer dryer", "signature washer"],
    "dishwashers": ["premium dishwasher", "luxury dishwasher", "signature dishwasher"],
    "refrigeration": ["premium fridge", "luxury refrigerator", "signature fridge"],
    "ranges": ["premium stove", "luxury range", "signature oven"],
    "accessories": ["signature accessories", "luxury accessories", "premium accessories"],

    // STUDIO
    "built-in wall ovens": ["studio wall oven", "luxury built-in oven", "premium wall oven"],
    "built-in cooktops": ["studio cooktop", "luxury cooktop", "premium cooktop"],
    "range hoods": ["studio hood", "luxury range hood", "premium hood"],
    "microwaves": ["studio microwave", "luxury microwave", "premium microwave"],
};

export const SUBCATEGORY_NAMING_MAP = {

    "refrigeration": "Refrigeration",
    "built-in cooking": "Built-in Cooking",
    "free-standing cooking": "Free-standing Cooking",
    "ventilation": "Ventilation",
    "dishwashers": "Dishwashers",
    "laundry": "Laundry",
    "front load": "Front Load",
    "washtower": "WashTower",
    "top load": "Top Load",
    "specialty laundry": "Specialty Laundry",
    "accessories": "Accessories",
    "36\" french door standard depth": "36\" French Door Standard Depth",
    "36\" french door counter depth": "36\" French Door Counter Depth",
    "33\" french door standard depth": "33\" French Door Standard Depth",
    "33\" french door counter depth": "33\" French Door Counter Depth",
    "30\" french door": "30\" French Door",
    "top and bottom mount": "Top and Bottom Mount",
    "side-by-side": "Side-by-Side",
    "column": "Column",
    "kimchi": "Kimchi",
    "electric slide-in ranges": "Electric Slide-in Ranges",
    "electric free-standing ranges": "Electric Free-standing Ranges",
    "induction ranges": "Induction Ranges",
    "gas ranges": "Gas Ranges",
    "wall ovens": "Wall Ovens",
    "cooktops": "Cooktops",
    "over-the-range microwaves": "Over-the-Range Microwaves",
    "countertop microwaves": "Countertop Microwaves",
    "built-in": "Built-in",

    // FRENCH - IF BUGGY - SPLIT THIS INTO NEW OBJECT AND USE LANG TO DETERMINE WHICH TO USE
    "réfrigérateur": "Réfrigérateur",
    "cuisson intégré": "Cuisson intégré",
    "cuisson autonome": "Cuisson autonome",
    "ventilation": "Ventilation",
    "lave-vaisselles": "Lave-vaisselles",
    "lessive": "Lessive",
    "chargement frontal": "Chargement frontal",
    "washtower": "WashTower",
    "chargement vertical": "Chargement vertical",
    "appareils spécialisés": "Appareils spécialisés",
    "porte à deux battants profondeur standard de 36 po": "Porte à deux battants profondeur standard de 36 po",
    "porte à deux battants profondeur de comptoir de 36 po": "Porte à deux battants profondeur de comptoir de 36 po",
    "porte à deux battants profondeur standard de 33 po": "Porte à deux battants profondeur standard de 33 po",
    "porte à deux battants profondeur de comptoir de 33 po": "Porte à deux battants profondeur de comptoir de 33 po",
    "porte à deux battants de 30 po": "Porte à deux battants de 30 po",
    "congélateur en haut et bas": "Congélateur en haut et bas",
    "côte-à-côte": "Côte-à-côte",
    "colonne": "Colonne",
    "kimchi": "Kimchi",
    "cuisinière encastrable électrique": "Cuisinière encastrable électrique",
    "cuisinières encastrable électriques": "Cuisinières encastrable électriques",
    "cuisinières à inductions": "Cuisinières à inductions",
    "cuisinière au gaz": "Cuisinière au gaz",
    "four mural": "Four mural",
    "surface de cuisson": "Surface de cuisson",
    "four à micro-ondes à hotte intégrée": "Four à micro-ondes à hotte intégrée",
    "four à micro-ondes de comptoir": "Four à micro-ondes de comptoir",
    "intégré": "Intégré"

}

export const CATEGORY_NAMING_MAP = {
    studio: 'LG STUDIO',
};

export const VALID_CATEGORIES = [
    'air-care',
    'air care', //FIX THIS
    'laundry',
    'refrigeration',
    'vacuums',
    'signature',
    'studio',
    'cooking',
    'dishwashers'
];

